





























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {Item, ListSection} from '@/store/models';
import user from '@/store/modules/user';

@Component({components: {List}})
export default class CompetitorInfo extends Vue {
  @Prop() readonly group!: any;

  contact1: string = '';
  contact2: string = '';
  contact3: string = '';
  contact4: string = '';
  contact5: string = '';

  mounted() {
    if (this.contacts) {
      let i = 1;
      for (const contact of this.contacts.split(';')) {
        (this as any)[`contact${i}`] = contact;
        i++;
      }
    }
    if (this.name === undefined) {
      this.init();
    }
  }

  init() {
    this.date = '';
    this.name = '';
    this.mail = '';
    this.phone = '';
    this.contact1 = '';
    this.contact2 = '';
    this.contact3 = '';
    this.contact4 = '';
    this.contact5 = '';

    const u = user.user;
    if (!u) {
      return;
    }
    this.name = u.FirstName + ' ' + u.LastName;
    this.mail = u.Email;

    // const d = new Date();
    // this.date = `${d.getFullYear()}-${this.pad(d.getMonth())}-${this.pad(d.getDay())}`;
  }

  pad(num: number) {
    if (num < 10) {
      return '0' + num;
    }
    return num;
  }

  get date() { return dokument.Texts[`analysis_info_date`]; }
  set date(value: string) { dokument.setText({Type: 'analysis_info_date', Text: value}); }

  get name() { return dokument.Texts[`analysis_info_name`]; }
  set name(value: string) { dokument.setText({Type: 'analysis_info_name', Text: value}); }

  get mail() { return dokument.Texts[`analysis_info_mail`]; }
  set mail(value: string) { dokument.setText({Type: 'analysis_info_mail', Text: value}); }

  get phone() { return dokument.Texts[`analysis_info_phone`]; }
  set phone(value: string) { dokument.setText({Type: 'analysis_info_phone', Text: value}); }

  get contacts() { return dokument.Texts[`analysis_info_contacts`]; }

  @Watch('contact1', { immediate: false, deep: false })
  title1Changed() {this.update(); }
  @Watch('contact2', { immediate: false, deep: false })
  title2Changed() {this.update(); }
  @Watch('contact3', { immediate: false, deep: false })
  title3Changed() {this.update(); }
  @Watch('contact4', { immediate: false, deep: false })
  title4Changed() {this.update(); }
  @Watch('contact5', { immediate: false, deep: false })
  title5Changed() {this.update(); }

  update() {
    const contacts = [this.contact1, this.contact2, this.contact3, this.contact4, this.contact5];
    const text = contacts.filter((x) => x !== '').join(';');
    dokument.setText({Type: 'analysis_info_contacts', Text: text});
  }

  get section(): any {
    return dokument.getItem(720) as Item;
  }

  get texts() {
    return dokument.Texts;
  }

  @Watch('texts', {immediate: true, deep: true})
  onData() {
    if (this.section.Hidden !== this.hidden) {
      const s = {
        Id: this.section.Id,
        Kind: this.section.Kind,
        Type: this.section.Type,
        SubType: this.section.SubType,
        Hidden: this.hidden,
        PrintOnly: this.section.PrintOnly,
      };
      dokument.updateItem(s);
    }
  }

  get hidden(): boolean {
    if (this.date || this.contacts) {
      return false;
    }
    return true;
  }
}
